import type { HTMLElementOrNull } from './types';

/**
 * Display a loading spinner in the target element
 */
export function showLoading(element: HTMLElementOrNull): void {
  if (!element) return;
  
  element.innerHTML = `
    <div style="text-align: center; padding: 2rem;">
      <div class="spinner"></div>
      <p style="margin-top: 1rem; color: var(--color-text-light);">Loading...</p>
    </div>
  `;
}

/**
 * Display an error message in the target element
 */
export function showError(element: HTMLElementOrNull, message: string): void {
  if (!element) return;
  
  element.innerHTML = `
    <div class="card" style="border-color: #ef4444; background: #fef2f2;">
      <p style="color: #dc2626; margin: 0;">❌ ${message}</p>
    </div>
  `;
}

/**
 * Display a success message in the target element
 */
export function showSuccess(element: HTMLElementOrNull, message: string): void {
  if (!element) return;
  
  element.innerHTML = `
    <div class="card" style="border-color: #10b981; background: #f0fdf4;">
      <p style="color: #059669; margin: 0;">✅ ${message}</p>
    </div>
  `;
}

/**
 * Safely get an element by ID
 */
export function getElementById(id: string): HTMLElementOrNull {
  return document.getElementById(id);
}

/**
 * Escape HTML to prevent XSS
 */
export function escapeHtml(unsafe: string): string {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

